import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageServicePrincipalsProjectList from 'hcp/components/page/service-principals/project/list';
import PageServicePrincipalsOrganizationList from 'hcp/components/page/service-principals/organization/list';

<template>
  {{pageTitle (t "page-title.access-control.service-principals.list")}}

  {{#if @controller.model.isProjectContext}}
    <PageServicePrincipalsProjectList
      @policy={{@controller.model.policy}}
      @policies={{@controller.model.policies}}
      @servicePrincipals={{@controller.model.servicePrincipals}}
      @servicePrincipalToRoleBindings={{@controller.model.servicePrincipalToRoleBindings}}
    />
  {{else}}
    <PageServicePrincipalsOrganizationList
      @organization={{@controller.model.organization}}
      @policy={{@controller.model.policy}}
      @servicePrincipals={{@controller.model.servicePrincipals}}
      @servicePrincipalToRoleBindings={{@controller.model.servicePrincipalToRoleBindings}}
    />
  {{/if}}
</template>
